export const VIEW_MENU_STORAGE_KEY = "selectedviewmenu";
export const MAX_TIME_TO_KEEP_LOCAL_STORAGE_MINUTES = 10;

export const BUGSNAG_API_CODE = process.env.REACT_APP_BUGSNAG_APP_CODE;